<template>
  <form class="bpl" v-if="bpl && $route.path != '/'">
    <h3>{{getResource('BPL_DocumentHeader')}} {{{header.title}}}</h3>
    <p>{{getResource('BPL_DocumentSubheader')}}</p>
    <select class="select bpl__select" v-model="bpl_current.BrandId">
      <option :value="item.Value" v-for="item in bpl.Brands">{{ item.Text }}</option>
    </select>
    <select class="select bpl__select" v-model="bpl_current.CompanyId" @change="changeCompany(bpl_current.CompanyId)">
      <option :value="item.Value" v-for="item in bpl.Companies">{{ item.Text }}</option>
    </select>
    <select class="select bpl__select" v-model="bpl_current.LanguageId">
      <option :value="item.Value" v-for="item in bpl.Languages">{{ item.Text }}</option>
    </select>
    <select class="select bpl__select" v-model="bpl_current.DealerId" v-if="$route.path.indexOf('images') === -1">
      <option :value="item.Value" v-for="item in bpl.Dealers">{{ item.Text }}</option>
    </select>
    <button class="button bpl__button" v-on:click.prevent="setBluePrintingLevel(bpl_current)">{{getResource('Go')}}</button>
    <tabs></tabs>
  </form>
</template>

<script>
import { getBluePrintingLevel, changeCompany, setBluePrintingLevel } from "./BluePrintingLevelActions";
import { getResource } from "../../vuex/helpers";
import Tabs from "./BluePrintingLevelTabs";

export default {
  vuex: {
    getters: {
      header: state => state.header,
      bpl: state => state.bpl,
      bpl_current: state => state.bpl_current
    },
    actions: { getBluePrintingLevel, changeCompany, setBluePrintingLevel, getResource }
  },
  components: { Tabs },
  ready: function () {
    this.getBluePrintingLevel();
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';
  @import '../../assets/scss/elements/button.scss';

  .bpl{
    background: rgba(0,0,0,0.5);
    width: 300px;
    float: left;
    color: $white;
    padding: 38px 30px 30px;
    line-height: 1.5em;

    h3{
      margin: 0;
      font-size: 16px;
      font-weight: normal;
    }

    p{
      margin-top: 0;
      color: $green_light;
    }

    &__select{
      width: 100%;
      margin-bottom: 10px;
    }

    &__button{
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// BluePrintingLevel.vue?939ab706